import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import styles from './index.css';
// icon
import applause from '../../assets/applause.png';
import slapFace from '../../assets/slapFace.png';
import thumbsUp from '../../assets/thumbsUp.png';

class Interaction extends React.Component {
    onAni(state) {
        this.props.onClick(state);
    }

    // 弹幕标示判断
    getDanmu(name) {
        // dianzan/hand/cai
        let url = '';

        switch (name) {
            case 'applause':
                url = applause;
                break;
            case 'slapFace':
                url = slapFace;
                break;
            case 'thumbsUp':
                url = thumbsUp;
                break;
            default:
                break;
        }

        return url;
    }

    render() {
        const { interaction, isShow } = this.props.item;

        return (
            <div className={styles.interactionWrap}>
                <div className={isShow ? 'showAni' : 'hideAni'}>
                    {interaction.map((item, index) => {
                        return (
                            <div key={index} className={styles.interaction} onClick={this.onAni.bind(this, item.state)}>
                                <LazyImg src={this.getDanmu(item.icon)} className={styles.itemImg} alt="" />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

Interaction.propTypes = {
    onClick: PropTypes.func,
    item: PropTypes.object,
};
export default Interaction;
